import Navbar from "./components/Navbar";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import SportsPage from "./pages/SportsPage";
import Footer from "./components/Footer";
import {LanguageProvider} from "./contexts/LanguageProvider";
import AttributionPage from "./pages/AttributionPage";

function App() {
  return (
      <BrowserRouter>
          <LanguageProvider>
              <Navbar />
              <Routes>
                  <Route path="/" element={<SportsPage />} />
                  <Route path="*" element={<AttributionPage />} />
              </Routes>
              <Footer />
          </LanguageProvider>
      </BrowserRouter>
  );
}

export default App;
